<a
  yat-link
  type="button"
  class="link link-secondary"
  (click)="onAddPersonClick()"
  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PERSONALIZATION"
  matomoClickAction="Add_Person">
  <yat-icon id="b6fcab08-9515-418d-a439-b4e313bd3a9f" name="plus-circle-duo"></yat-icon>
  {{ 'commercialCheckout.personalization.buttonAddPerson.add' | transloco }}
</a>
